import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FoodFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M6.35005 8.86667V4H4.55005V8.86667C4.55005 10.3578 5.75888 11.5667 7.25005 11.5667H7.65005V9.76667H7.25005C6.75299 9.76667 6.35005 9.36372 6.35005 8.86667ZM15.9501 15.0285V20H14.1501L14.1501 4H15.9501V4.01728C17.8891 4.05282 19.4501 5.63579 19.4501 7.58333V12.9167V13.5067L18.9089 13.742L15.9501 15.0285ZM10.7501 4V8.86667C10.7501 9.36372 10.3471 9.76667 9.85006 9.76667H9.45006V4H7.65006L7.65005 20H9.45006L9.45006 11.5667H9.85006C11.3412 11.5667 12.5501 10.3578 12.5501 8.86667V4H10.7501Z"
      />
    </SvgIcon>
  );
});
